import React from 'react';
import PropTypes from 'prop-types';

const withContext = (WrappedComponent, context) => {

    class ContextProvider extends React.Component {

        getChildContext() {

            return context;
        }

        render() {

            return <WrappedComponent {...this.props}/>;
        }
    }

    ContextProvider.childContextTypes = {};

    Object.keys(context).forEach(key => {

        ContextProvider.childContextTypes[key] = PropTypes.any.isRequired;
    });

    return ContextProvider;
};

export default withContext;



// WEBPACK FOOTER //
// ./src/components/withContext.js